import { observer } from 'mobx-react-lite'
import { Navigate } from 'react-router-dom'
import { useUsersIndex } from 'app/components/users-index/useUsersIndex'
import { UsersIndexShadcnComponent } from 'app/components/users-index/UsersIndexShadcnComponent'
import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useUser } from 'app/utils'

export default observer(function UsersIndex(): React.ReactElement {
  const me = useUser()
  const checkPermission = useCheckPermission()
  const { users, columns, filters, initialSort, canEditUser, userIsOrg, onSearchValueChange } = useUsersIndex()

  if (!me) return <></>

  // In workspace context, redirect to the active tab.
  if (me.workspaceId) {
    return <Navigate to="/settings/users/active" replace />
  }

  const canManageUsers = me.type === `super` || checkPermission([`org:settings:manage-users`, `users:manage`])
  if (!canManageUsers) {
    return <Navigate to="/" replace />
  }

  return (
    <UsersIndexShadcnComponent
      users={users}
      columns={columns}
      filters={filters}
      initialSort={initialSort}
      canEditUser={canEditUser}
      userIsOrg={userIsOrg}
      isSuperUser={me.type === `super`}
      inWorkspace={!!me.workspaceId}
      onSearchValueChange={onSearchValueChange}
    />
  )
})
